import Explorer from "../Components/explorer";
import Footer from "../Components/footer";
import Visual from "../Components/Visual/visual";

function Default() {
  return (
    <>
      {/*<Visual />*/}
      <Explorer />
      <Footer />
    </>
  );
}
export default Default;
